import { Grid } from "@mui/material";
import React, { Fragment } from "react";
import { Input } from "../../../../controls";
import SectionLabel from "./SectionLabel";

const InventoryFields = ({ values, setValues }) => {
  const handleInpChg = (e, val) => {
    const { name, value } = e.target;
    setValues((j) => ({
      ...j,
      inventories: [
        ...j.inventories.map((i) =>
          i.outletId === val.outletId ? { ...i, [name]: value } : i
        ),
      ],
    }));
  };

  return (
    <>
      <Grid item xs={12}>
        <SectionLabel label="Inventory levels" />
      </Grid>

      {values.inventories.map((inv, index) => {
        return (
          <Fragment key={index}>
            {values.inventories.length > 1 && (
              <Grid item xs={12} md={2} className="flex items-center">
                <span className="text-[18px] text-gray-500 lg:pl-5">
                  {inv.outletName} :
                </span>
              </Grid>
            )}
            <Grid item xs={12} md={3.33}>
              <Input
                label="Current Inventory"
                name="inInv"
                value={inv.inInv}
                type="number"
                onChange={(e) => handleInpChg(e, inv)}
                size="small"
                disabled={values.id ? true : false}
              />
            </Grid>
            <Grid item xs={12} md={3.33}>
              <Input
                label="Re-Order Point"
                name="reOrderPoint"
                value={inv.reOrderPoint}
                type="number"
                onChange={(e) => handleInpChg(e, inv)}
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={3.33}>
              <Input
                label="Re-Order Quantity"
                name="reOrderQty"
                value={inv.reOrderQty}
                type="number"
                onChange={(e) => handleInpChg(e, inv)}
                size="small"
              />
            </Grid>
          </Fragment>
        );
      })}
    </>
  );
};

export default InventoryFields;
